import { getLocationPathname } from 'core/utilities';

type InitialStateRouter = {
  currentPathname: string;
  prevPathname: string;
};

export const initialState: InitialStateRouter = {
  currentPathname: getLocationPathname(),
  prevPathname: '',
};
